const TURKISH_CHAR_MAP = {
  'ı': 'i', 'İ': 'I',
  'ş': 's', 'Ş': 'S',
  'ğ': 'g', 'Ğ': 'G',
  'ç': 'c', 'Ç': 'C',
  'ö': 'o', 'Ö': 'O',
  'ü': 'u', 'Ü': 'U',
};
const TURKISH_REGEX = new RegExp(`[${Object.keys(TURKISH_CHAR_MAP).join('')}]`, 'g');

export function toAscii(str) {
  return str
    .replace(TURKISH_REGEX, (ch) => TURKISH_CHAR_MAP[ch])
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function sanitizeFileName(name) {
  return toAscii(name).replace(/[^a-zA-Z0-9_-]/g, '_');
}
